export const resolveSocialNetworkName = (name: string) => {
  const SOCIAL_NETWORK_NAMES = {
    facebook: 'Facebook',
    x: 'X',
    instagram: 'Instagram',
    youtube: 'Youtube',
  };

  return SOCIAL_NETWORK_NAMES[name] || undefined;
};
